
/* styles */
require("!!vue-style-loader!css-loader!./node_modules/vue-loader/lib/style-rewriter?id=data-v-44138184!sass-loader!./node_modules/vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!./node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!./node_modules/vue-loader/lib/template-compiler?id=data-v-44138184!./node_modules/vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./index.vue
// module id = 1
// module chunks = 0